webpackJsonp([5556081740406813000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/photos-oslo.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"name": "oslo",
			"photos": [
				"oslo/DSC_0493.jpg",
				"oslo/DSC_0494.jpg",
				"oslo/DSC_0495.jpg",
				"oslo/DSC_0497.jpg",
				"oslo/DSC_0500.jpg",
				"oslo/DSC_0507.jpg",
				"oslo/DSC_0523.jpg",
				"oslo/DSC_0528.jpg",
				"oslo/DSC_0530.jpg",
				"oslo/DSC_0535.jpg",
				"oslo/DSC_0539.jpg",
				"oslo/DSC_0541.jpg",
				"oslo/DSC_0543.jpg",
				"oslo/DSC_0546.jpg"
			],
			"next": {
				"name": "gothenburg"
			},
			"previous": {
				"name": "budapest"
			}
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---photos-oslo-b618566f34d9064f627c.js